// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"59e83ffc","703":"f24d17f0","787":"5966f191"}[chunkId] + ".chunk.js";
};